import { httpGet_New } from './api.service';

export const getVersion = async (): Promise<{ version: string } | null> => {
  try {
    const data = await httpGet_New<{ version: string }>('api/public/version');
    return data;
  } catch (e) {
    return null;
  }
};

export default { getVersion };
